import { useAppState } from "@/store/useApp";

export const useOnboardingVisibility = (): boolean => {
  const onboardingCompleted = useAppState(
    (state) => state.user?.onboardingCompleted ?? false
  );

  return !onboardingCompleted;
};


